export default __webpack_public_path__ + "static/media/MelbourneLevel1West.1e79dc77.jpg";